module.exports = __webpack_public_path__ + "assets/img/in_(3).163a83b9.gif";